import { Input } from './ui/Input';
import { Label } from './ui/Label';

/** The fresh 2FA code field every step-up action asks for. */
export function StepUpField({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (next: string) => void;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>Code from the authenticator app (or a recovery code)</Label>
      <Input
        id={id}
        inputMode="text"
        autoComplete="one-time-code"
        placeholder="123 456"
        className="font-mono text-base tracking-widest"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
      />
    </div>
  );
}
